import React, { Fragment } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";

const CustomToolbar = (p) => {
    const classes = p.classes;

    return (
        <Fragment>
            <Tooltip title={"Adicionar Grupo"}>
                <IconButton className={classes.iconButton} onClick={p.handleAdicionar}>
                    <AddIcon className={classes.deleteIcon} />
                </IconButton>
            </Tooltip>
        </Fragment>
    );
};

export default withStyles(
    (theme) => ({
        iconButton: {
            "&:hover": {
                color: theme.palette.primary.main,
            },
        },
    }),
    { name: "CustomToolbar" }
)(CustomToolbar);
